export default __webpack_public_path__ + "static/invision-a53786f7779e88b0b427eb21920690e7.png";